import SaveAltIcon from '@mui/icons-material/SaveAlt';
import { Button, Typography } from '@mui/material';

export type DownloadCSVButtonUIColor = 'mediaInteraction' | 'primary' | 'primaryLighter' | 'primaryLight';

interface DownloadCSVButtonUIProps {
  onClick: () => void;
  color: DownloadCSVButtonUIColor;
}

export default function DownloadCSVButtonUI(props: DownloadCSVButtonUIProps) {
  const { onClick, color } = props;

  return (
    <Button
      sx={{ height: '32px' }}
      variant="contained"
      color={color}
      startIcon={<SaveAltIcon />}
      onClick={() => onClick()}
    >
      <Typography>Download</Typography>
    </Button>
  );
}
